import { render, staticRenderFns } from "./AlarmCreate.vue?vue&type=template&id=2aa1ec76"
import script from "./AlarmCreate.vue?vue&type=script&lang=js"
export * from "./AlarmCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports